import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const initialState = {
  loggedIn: false,
  appReady: false,
  currentStep: null,
  currentSubstep: null,
  tokenData: {},
  user: {
    context: {},
    details: {},
  },
  registrations: {},
  walletInstruments: [],
  detect: {}
};

export default new Vuex.Store({
  state: JSON.parse(JSON.stringify(initialState)),

  getters: {},

  mutations: {
    reset(state) {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
      console.log("[STORE resetted]: ", state);
    },
    setTokenData(state, payload) {
      state.tokenData = payload;
      console.log("[STORE updated]: TOKEN DATA ", state.tokenData);
    },
    setUser(state, payload) {
      const s = state.user;
      state.user = {
        ...s,
        ...payload
      };
      console.log("[STORE updated]: USER ", state.user);
    },
    setCurrentStep(state, payload) {
      state.currentStep = payload;
    },
    setCurrentSubstep(state, payload) {
      state.currentSubstep = payload;
    },

    setRegistrations(state, payload) {
      state.registrations = payload;
      console.log("[Store Updated]: REGISTRATIONS ", state.registrations);
    },
    setDetect(state, payload) {
      state.detect = payload;
      console.log("[STORE updated]: DETECT ", state.detect);
    },
    setLoggedIn(state, payload) {
      state.loggedIn = payload;
      console.log("[STORE updated]: LOGGED IN ", state.loggedIn);
    },

    setAppReady(state, payload) {
      state.appReady = payload;
      console.log("[STORE updated]: APP READY ", state.appReady);
    },
    setWalletInstruments(state, payload) {
      state.walletInstruments = payload;
      console.log("[STORE updated]: WALLET INSTRUMENTS ", state.walletInstruments);
    },
  },

  actions: {
    setTokenData(context, payload) {
      context.commit("setTokenData", payload);
    },
    setCurrentStep(context, payload) {
      context.commit("setCurrentStep", payload);
    },
    setCurrentSubstep(context, payload) {
      context.commit("setCurrentSubstep", payload);
    },
    setUser(context, payload) {
      context.commit("setUser", payload);
    },
    setRegistrations(context, payload) {
      context.commit("setRegistrations", payload);
    },
    setLoggedIn(context, payload) {
      context.commit('setLoggedIn', payload)
    },
    setAppReady(context, payload) {
      context.commit('setAppReady', payload)
    },
    setDetect(context, payload) {
      context.commit('setDetect', payload)
    },
    setWalletInstruments(context, payload) {
      context.commit('setWalletInstruments', payload)
    },
  }
});
